import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

import { COMPONENTS } from "./components";
import { LegalRoutingModule } from "./legal-routing.module";

@NgModule({
    providers: [],
    exports: [...COMPONENTS],
    imports: [CommonModule, LegalRoutingModule, ...COMPONENTS],
})
export class LegalModule {
  static forRoot(): ModuleWithProviders<LegalModule> {
    return {
      ngModule: LegalModule,
      providers: [],
    };
  }
}
